exports.init = function ($) {

  let currentWidth = $(window).width();
  let initialTrigger = false;
  let productTime;


  const clearProducts = () => {
    initialTrigger = false;
    $('.ingredient-header').removeClass('active');
    $('.nutrition-header').removeClass('active');
    $('.nutrition-content').css('display', 'none');
    $('.ingredient-content').css('display', 'none');
    $(".nutrition-header").off();
    nutritionEvent();
  }

  const nutritionEvent = () => {
    if (currentWidth > 768) {
      $('.nutrition-header.desktop').on('click', function () {
        $(this).toggleClass('active');
        $('.nutrition-content.desktop').slideToggle(function () {
          initialTrigger = true;
        });
        if (initialTrigger && $('.ingredient-header').hasClass('active')) {
          $('.ingredient-content').css('display', 'none');
          $('.ingredient-header').removeClass('active');
        }
        // console.log('test');
      });
    } else {
      $('.nutrition-header.mobile').on('click', function () {
        $(this).toggleClass('active');
        $('.nutrition-content.mobile').slideToggle(function () {
          initialTrigger = true;
        });
        if (initialTrigger && $('.ingredient-header').hasClass('active')) {
          $('.ingredient-content').css('display', 'none');
          $('.ingredient-header').removeClass('active');
        }
      });
    }
  }

  $('.ingredient-header').on('click', function () {
    $(this).toggleClass('active');
    $('.ingredient-content').slideToggle(function () {
      initialTrigger = true;
    });
    if (initialTrigger && $('.nutrition-header').hasClass('active')) {
      $('.nutrition-content.desktop').css('display', 'none');
      $('.nutrition-header.desktop').removeClass('active');
    }
  });

  nutritionEvent();


  $(window).resize(function () {
    currentWidth = $(window).width();
    clearTimeout(productTime);
    productTime = setTimeout(clearProducts, 500);
  });

};